// React
import React, { useState, useEffect } from "react";

// Internal Components
import PlanningTile from "./planning/PlanningTile";
import ProcessingTile from "./processing/ProcessingTile";
import PrimingTile from "./priming/PrimingTile";
import {
  FullDockMobileOne,
  FullDockMobileTwo,
} from "../../components/FullDockMobile";
import FullDock from "../../components/FullDock";
import DayDock from "../../components/DayDock";

function TileContainer({
  load,
  today,
  objectives,
  tooltipPosition,
  continuation,
  background,
  startSlider,
  handleChange,
  handleMouseState,
  handleColumnChange,
  handleSubmit,
  handleTodayAiChange,
  meyear,
  yearList,
  dayList,
  yearid,
  previousDay,
  deleteTodayKey,
  closeTooltip,
  realtimeActivate,
  ...props
}) {
  const [isOn, setIsOn] = useState(false);
  const [animation, setAnimation] = useState();

  const handlePlayingChange = (bool) => {
    if (bool) {
      setAnimation(`blur(0px) sepia(0%)`);
    } else {
      setAnimation(`blur(1px) sepia(60%)`);
    }
  };

  return (
    <form>
      <div
        className="tile__container"
        style={{
          filter: animation,
          transition: "filter 5s ease-out",
        }}
      >
        <PrimingTile
          today={today}
          startSlider={startSlider}
          tooltipPosition={tooltipPosition}
          background={background}
          realtimeActivate={realtimeActivate}
          handleChange={handleChange}
        />
        <FullDockMobileOne
          yearid={yearid}
          yearList={yearList}
          load={load}
          meyear={meyear && meyear.obj}
          handleMouseState={handleMouseState}
        />

        <PlanningTile
          today={today}
          tooltipPosition={tooltipPosition}
          startSlider={startSlider}
          continuation={continuation}
          background={background}
          handleChange={handleChange}
          deleteTodayKey={deleteTodayKey}
        />
        <FullDockMobileTwo
          objectives={objectives}
          handleColumnChange={handleColumnChange}
        />
        <ProcessingTile
          today={today}
          tooltipPosition={tooltipPosition}
          startSlider={startSlider}
          background={background}
          handleChange={handleChange}
        />
      </div>
      <FullDock
        load={load}
        objectives={objectives}
        meyear={meyear && meyear}
        yearList={yearList}
        today={today}
        previousDay={previousDay}
        handleMouseState={handleMouseState}
        handleColumnChange={handleColumnChange}
        handleSubmit={handleSubmit}
        handlePlayingChange={handlePlayingChange}
        handleTodayAiChange={handleTodayAiChange}
      />
      {/* <DayDock
        load={load}
        previousDay={previousDay}
        yearList={yearList}
        dayList={dayList}
        today={today}
        handleSubmit={handleSubmit}
        handleTodayAiChange={handleTodayAiChange}
      /> */}
    </form>
  );
}

export default TileContainer;
